export default {
  methods: {
    updateCart(order) {
      const event = new CustomEvent('cartupdate', {
        detail: {
          item_count: order.item_count
        }
      })
      document.dispatchEvent(event)
    }
  }
}
